import {useMediaQuery} from '@mui/material';
import theme from 'src/theme';

/**
 * The three widths the dashboard is designed for. The values are MUI's own defaults, so a tier
 * here and a `{xs, sm, md}` object in an sx prop always mean the same thing.
 */
export interface ScreenTier {
    /** Under 600px: one column, a bottom bar, sheets instead of dialogs. */
    isPhone: boolean;
    /** 600 to 900px: the same cards, two per row, with the desktop's drawer. */
    isTablet: boolean;
    /** From 900px up: the table layout. */
    isDesktop: boolean;
    /** Anything narrower than a desktop - cards rather than a grid. */
    isCompact: boolean;
}

export const useScreenTier = (): ScreenTier => {
    const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    return {isPhone, isTablet, isDesktop, isCompact: !isDesktop};
};
